import axios from 'axios'
import Cookies from 'js-cookie'

import { api, cookies, urls } from 'app/utils/constants'

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_ADDRESS,
    timeout: 10_000,
    headers: {
        Authorization: `JWT ${Cookies.get(cookies.ACCESS_TOKEN)}`,
        'Content-Type': 'application/json',
        accept: 'application/json',
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
    },
})

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        const originalRequest = error.config

        // Prevent infinite loops in login
        if (
            error.response.status === 401 &&
            originalRequest.url === api.auth.LOGIN
        ) {
            return Promise.reject(error)
        }

        // Prevent infinite loops in refresh tokens
        if (
            error.response.status === 401 &&
            originalRequest.url === api.auth.REFRESH_TOKENS
        ) {
            window.location.href = urls.auth.LOGIN
            return Promise.reject(error)
        }

        if (
            error.response.data.code === 'token_not_valid' ||
            error.response.status === 401 ||
            error.response.statusText === 'Unauthorized'
        ) {
            const refreshToken =
                Cookies.get(cookies.REFRESH_TOKEN) ??
                localStorage.getItem(cookies.REFRESH_TOKEN)

            if (refreshToken) {
                const tokenParts = JSON.parse(atob(refreshToken.split('.')[1]))

                // exp date in token is expressed in seconds, while now() returns milliseconds:
                const now = Math.ceil(Date.now() / 1000)

                if (tokenParts.exp > now) {
                    return axiosInstance
                        .post(api.auth.REFRESH_TOKENS, {
                            refresh: refreshToken,
                        })
                        .then((response) => {
                            Cookies.set(
                                cookies.ACCESS_TOKEN,
                                response.data.access,
                                cookies.OPTIONS,
                            )

                            Cookies.set(
                                cookies.REFRESH_TOKEN,
                                response.data.refresh,
                                cookies.OPTIONS,
                            )

                            axiosInstance.defaults.headers['Authorization'] =
                                'JWT ' + response.data.access
                            originalRequest.headers['Authorization'] =
                                'JWT ' + response.data.access

                            return axiosInstance(originalRequest)
                        })
                        .catch((err) => {
                            console.error(err)
                        })
                } else {
                    window.location.href = urls.auth.LOGIN
                }
            } else {
                console.error(error)
            }
        }

        // specific error handling done elsewhere
        return Promise.reject(error)
    },
)

export default axiosInstance
